export const V1_ADD_SEAT_TRADE_NOTIFICATIONS = 'V1_ADD_SEAT_TRADE_NOTIFICATIONS'

export default data => {
  return {
    type: V1_ADD_SEAT_TRADE_NOTIFICATIONS,
    data,
  }
}
